<div class="flex-1 flex flex-col gap-2">
  <div class="p-2 flex flex-row items-center justify-center gap-2">
    @for (stepStatus of stepperProgress(); track $index; let isLast = $last) {
      <div class="flex items-center justify-center w-4 h-4">
        @if (stepStatus.active) {
          <i class="fa-solid fa-circle text-slate-400"></i>
        }

        @if (stepStatus.done) {
          <i class="fa-solid fa-circle-check text-green-900"></i>
        }

        @if (!stepStatus.active && !stepStatus.done) {
          <i class="fa-light fa-circle text-slate-400"></i>
        }
      </div>

      @if (!isLast) {
        <div
          class="h-px {{
            $index < indexOfActiveStep() ? 'bg-slate-900' : 'bg-slate-200'
          }} w-24"
        ></div>
      }
    }
  </div>

  <div class="flex-1 flex">
    <div #stepContainer class="flex-1 flex"></div>
  </div>
</div>
